import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import HomePage from './components/HomePage';
import LoginPage from './components/LoginPage';
import RegistrationPage from './components/RegistrationPage';
import TermsAndConditions from './components/TermsAndConditions';
import Dashboard from "./components/Dashboard";
import Appointments from "./components/Appointments";
import AddUser from "./components/AddUser";
import EditUser from "./components/EditUser";
import UsersList from "./components/UsersList";
import AddDoctor from "./components/AddDoctor";
import EditDoctor from "./components/EditDoctor";
import DoctorsList from "./components/DoctorsList";
import ForgotPassword from "./components/ForgotPassword"; // Import Forgot Password Page
import VerificationPage from "./components/VerificationPage";
import FirebaseDiagnostic from "./components/FirebaseDiagnostic";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // User is signed in, get token and store it
        try {
          const token = await user.getIdToken();
          localStorage.setItem("token", token);
          setIsAuthenticated(true);
        } catch (error) {
          console.error("Error getting token:", error);
          setIsAuthenticated(false);
        }
      } else {
        // User is signed out
        localStorage.removeItem("token");
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Show login page as the first page */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />} />
        <Route path="/appointments" element={isAuthenticated ? <Appointments /> : <Navigate to="/login" replace />} />
        <Route path="/users" element={isAuthenticated ? <UsersList /> : <Navigate to="/login" replace />} />
        <Route path="/add-user" element={isAuthenticated ? <AddUser /> : <Navigate to="/login" replace />} />
        <Route path="/edit-user/:userId" element={isAuthenticated ? <EditUser /> : <Navigate to="/login" replace />} />
        <Route path="/doctors" element={isAuthenticated ? <DoctorsList /> : <Navigate to="/login" replace />} />
        <Route path="/add-doctor" element={isAuthenticated ? <AddDoctor /> : <Navigate to="/login" replace />} />
        <Route path="/edit-doctor/:doctorId" element={isAuthenticated ? <EditDoctor /> : <Navigate to="/login" replace />} />
        <Route path="/home" element={isAuthenticated ? <HomePage /> : <Navigate to="/login" replace />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify" element={<VerificationPage />} />
        <Route path="/firebase-diagnostic" element={<FirebaseDiagnostic />} />
      </Routes>
    </Router>
  );
}

export default App;
